import config from '@/config'
import { getAppState } from '@/redux/store'
import moment from 'moment'

const urls = {
  single: 'document',
  multiple: 'documents',
}

const resourceUrl = `${config.resourceHost}file`
const accountUrl = `${config.resourceHost}document`

export default {
  resourceUrl,
  global: config,
  listSetting: `${config.resourceHost}setting/userlist/document`,

  analyzeFileUrl: (fileId) => `${resourceUrl}/${fileId}/analyze`,
  uploadUrl: `${resourceUrl}/upload`,
  getUpdateUrl: (id) => `${resourceUrl}/${id}/meta`,
  accountUrls: {
    createAccount: `${accountUrl}/createAccount`,
    fetchAccount: `${accountUrl}/account`,
    getLogin: `${accountUrl}/login`,
    updateApiKey: `${accountUrl}/updateApiKey`,
    updateSettings: `${accountUrl}/settings`,
  },
  subscriptionUrls: {
    getSubscriptionModulesByType: (type) => `${config.resourceHost}subscription/modules/${type}`,
  },

  gmiLoginUrl: 'https://login.getmyinvoices.com/',

  clientUrl: urls,

  routes: {
    details: `/${urls.single}/`,
    list: `${config.resourceHost}${urls.multiple}`,
    listCount: `${config.resourceHost}${urls.multiple}/count`,
    folders: `${config.resourceHost}${urls.multiple}/folders`,
    setup: `/${urls.multiple}/setup`,
  },

  filters: [
    { name: 'all', title: 'Alle', filter: 'all', quickFilter: null },
    {
      name: 'lastUpdated',
      title: 'Zuletzt',
      quickFilter: {
        updatedAt: {
          dateFrom: moment().subtract(24, 'hours').toDate(),
          dateTo: moment().endOf('day').toDate(),
          filterType: 'datetime',
          type: 'inRange',
        },
      },
    },
    {
      name: 'approved',
      title: 'Freigegeben',
      quickFilter: {
        isShared: {
          type: 'set',
          values: [true],
        },
      },
    },
    {
      name: 'favorite',
      title: 'Favoriten',
      quickFilter: {
        isFavorite: {
          type: 'set',
          values: [true],
        },
      },
    },
    {
      name: 'assigned',
      title: 'Verknüpft',
      quickFilter: {
        operator: 'OR',
        isAssigned: {
          type: 'set',
          values: [true],
        },
        externalOwnerSystem: {
          filterType: 'text',
          type: 'equals',
          filter: 'desktop',
        },
      },
    },
    {
      name: 'notAssigned',
      title: 'Unverknüpft',
      quickFilter: {
        isAssigned: {
          type: 'set',
          values: [false],
        },
        externalOwnerSystem: {
          filterType: 'nullValues',
          type: 'null',
        },
      },
    },
    {
      name: 'manuallyPaid',
      title: 'Bezahlt',
      quickFilter: {
        payedAt: {
          filterType: 'nullValues',
          type: 'notNull',
        },
      },
    },
    {
      name: 'noFolder',
      title: 'Kein Ordner festgelegt',
      shouldHide: () => !!getAppState().document.list.currentFolder?.id,
      quickFilter: {
        folderId: {
          filterType: 'nullValues',
          type: 'null',
        },
      },
    },
    {
      name: 'noSystemDocuments',
      title: 'Keine Systemdokumente',
      shouldHide: () => true,
      quickFilter: {
        invoiceId: {
          filterType: 'nullValues',
          type: 'null',
        },
        cancellationId: {
          filterType: 'nullValues',
          type: 'null',
        },
        isAssigned: {
          type: 'set',
          values: [false],
        },
        externalOwnerSystem: {
          filterType: 'nullValues',
          type: 'null',
        },
      },
    },
    {
      name: 'noInvoices',
      title: 'Keine Rechnungen',
      shouldHide: () => true,
      quickFilter: {
        invoiceId: {
          filterType: 'nullValues',
          type: 'null',
        },
      },
    },
    {
      name: 'onlyDocuments',
      title: 'Nur Dokumente',
      shouldHide: () => true,
      quickFilter: {
        mimetype: {
          filterType: 'set',
          type: 'equals',
          filter: 'application/pdf',
        },
      },
    },
  ],
}
